module.exports = __webpack_public_path__ + "img/grow_5.167f2580.png";